console.log('form-utilities.js script loaded');

// Wrap submit button in a custom div
function wrapSubmitButton () {
    const formFooters = document.querySelectorAll(".gform-footer");

    formFooters.forEach((formFooter) => {
        const submitBtn = formFooter.querySelector('input[type="submit"]');

        if (submitBtn && !submitBtn.parentElement.classList.contains("custom-submit")) {
            const wrapper = document.createElement("div");
            wrapper.className = "custom-submit";
            submitBtn.parentNode.insertBefore(wrapper, submitBtn);
            wrapper.appendChild(submitBtn);
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    const targetNode = document.body;

    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === "childList" || mutation.type === "subtree") {
                wrapSubmitButton();
                break;
            }
        }
    });

    observer.observe(targetNode, {
        childList: true,
        subtree: true,
    });
});

// Select All checkbox for multi-select field
document.addEventListener('DOMContentLoaded', function () {
    const selectAllCheckbox = document.querySelector('#choice_4_28_1');
    const multiSelect = document.querySelector('#input_4_8');

    if (selectAllCheckbox && multiSelect) {
        // Handle "Select All" checkbox toggle
        selectAllCheckbox.addEventListener('change', function () {
        const isChecked = this.checked;

        for (let option of multiSelect.options) {
            option.selected = isChecked;
        }

        // Trigger change event for Gravity Perks Advanced Select
        const event = new Event('change', { bubbles: true });
        multiSelect.dispatchEvent(event);
        });

        // Handle manual changes to the multi-select
        multiSelect.addEventListener('change', function () {
        const total = multiSelect.options.length;
        const selected = Array.from(multiSelect.options).filter(opt => opt.selected).length;

        // If not all selected, uncheck "Select All"
        if (selected < total) {
            selectAllCheckbox.checked = false;
        } 
        // If all are selected manually, check "Select All"
        else if (selected === total) {
            selectAllCheckbox.checked = true;
        }
        });
    }
});

/**
 * Map click → county multi-select (form 4, field 8)
 * - Adds the clicked county if it exists in the menu
 * - Does not remove on a second click
 * - Counties with no jobs are skipped (job_count < 1, or not in the GF menu)
 *
 * Uses mapEntryClicked so this works even when the map DB action is still "none"
 * (map click settings are stored in post meta and are not deployed via git-ftp).
 */
(function () {
    const MAP_ID = 390;
    const SELECT_ID = 'input_4_8';

    function normalizeCountyName (value) {
        return String(value || '')
            .replace(/\s+County$/i, '')
            .replace(/^Saint\s+/i, 'St. ')
            .replace(/\./g, '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();
    }

    function getCountySelect () {
        return document.getElementById(SELECT_ID);
    }

    function getTomSelect (select) {
        if (!select) {
            return null;
        }
        return select.tomselect || window.GPAdvancedSelect_4_8 || null;
    }

    function getCandidateNames (data) {
        return [data.rename, data.name, data.job_text]
            .filter(Boolean)
            .map(normalizeCountyName);
    }

    function findCountyOption (select, data) {
        const candidates = getCandidateNames(data);

        return Array.from(select.options).find((option) => {
            return candidates.includes(normalizeCountyName(option.text));
        });
    }

    function findTomSelectValue (tomSelect, data) {
        const candidates = getCandidateNames(data);
        const valueField = tomSelect.settings.valueField || 'value';
        const labelField = tomSelect.settings.labelField || 'text';

        const match = Object.values(tomSelect.options).find((option) => {
            return candidates.includes(normalizeCountyName(option[labelField]));
        });

        return match ? String(match[valueField]) : null;
    }

    function addCountyToSelect (data) {
        if (!data) {
            return false;
        }

        // Prefer explicit job_count when present (from county-jobs.php)
        if (data.job_count !== undefined && data.job_count !== null && Number(data.job_count) < 1) {
            return false;
        }

        const select = getCountySelect();
        if (!select) {
            return false;
        }

        const tomSelect = getTomSelect(select);
        let value = null;
        let label = data.rename || data.name;

        if (tomSelect) {
            value = findTomSelectValue(tomSelect, data);
        }

        if (!value) {
            const option = findCountyOption(select, data);
            if (option) {
                value = String(option.value);
                label = option.text;
            }
        }

        // No matching menu option (e.g. county has no open jobs in GPPA list)
        if (!value) {
            return false;
        }

        if (tomSelect) {
            if (!tomSelect.options[value]) {
                tomSelect.addOption({
                    id: value,
                    value: value,
                    text: label
                });
            }

            // Add only — leave already-selected counties alone
            if (!tomSelect.items.map(String).includes(String(value))) {
                tomSelect.addItem(String(value), true);
                select.dispatchEvent(new Event('change', { bubbles: true }));
            }
            return true;
        }

        const option = findCountyOption(select, data);
        if (option && !option.selected) {
            option.selected = true;
            select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        return true;
    }

    function getClickedRegionData (container) {
        const mapId = String(container.id || '').replace(/^map_/, '');
        const maps = (window.iMapsManager && window.iMapsManager.maps) || {};
        const mapEntry = maps[mapId] || maps[MAP_ID] || Object.values(maps)[0];
        if (!mapEntry || !mapEntry.map || !mapEntry.map.lastClickedEntry) {
            return null;
        }

        const entry = mapEntry.map.lastClickedEntry;
        if (entry.dataItem && entry.dataItem.dataContext) {
            return entry.dataItem.dataContext;
        }
        if (entry.dataItems && entry.dataItems.first && entry.dataItems.first.dataContext) {
            return entry.dataItems.first.dataContext;
        }
        return null;
    }

    function bindMapCountyClicks () {
        document.querySelectorAll('[id^="map_"]').forEach((container) => {
            if (container.dataset.countyClickBound === '1') {
                return;
            }
            container.dataset.countyClickBound = '1';
            container.addEventListener('mapEntryClicked', function () {
                const data = getClickedRegionData(container);
                if (data) {
                    addCountyToSelect(data);
                }
            });
        });
    }

    // Public entry point (also used if map DB Custom Action is configured)
    window.accaSelectCountyFromMap = addCountyToSelect;
    window['customRegionAction_' + MAP_ID] = function (data) {
        addCountyToSelect(data);
    };

    document.addEventListener('DOMContentLoaded', function () {
        bindMapCountyClicks();
        const observer = new MutationObserver(bindMapCountyClicks);
        observer.observe(document.body, { childList: true, subtree: true });
    });
})();

// Skills Checkbox Handler for Multiple Forms
// Handles the behavior where selecting "no skills necessary" unchecks all other skill options
// and selecting any other skill option unchecks "no skills necessary"
document.addEventListener('DOMContentLoaded', function() {
    // Configuration for different forms
    const formConfigs = [
        {
            formId: 1,
            fieldId: 26,
            noSkillsChoiceId: 1
        },
        {
            formId: 4,
            fieldId: 10,
            noSkillsChoiceId: 26
        }
    ];
    
    // Process each form configuration
    formConfigs.forEach(config => {
        setupSkillsCheckboxHandler(config);
    });
    
    function setupSkillsCheckboxHandler(config) {
        const { formId, fieldId, noSkillsChoiceId } = config;
        
        // Get the "no skills necessary" checkbox
        const noSkillsCheckbox = document.getElementById(`choice_${formId}_${fieldId}_${noSkillsChoiceId}`);
        
        if (!noSkillsCheckbox) {
            return; // Exit if the checkbox doesn't exist for this form
        }
        
        // Get all other skill checkboxes
        const otherSkillCheckboxes = [];
        
        // Find all checkboxes in the field by looking for elements with IDs that match the pattern
        const allCheckboxes = document.querySelectorAll(`input[id^="choice_${formId}_${fieldId}_"]`);
        
        allCheckboxes.forEach(checkbox => {
            // Skip the "no skills necessary" checkbox
            if (checkbox.id !== `choice_${formId}_${fieldId}_${noSkillsChoiceId}`) {
                otherSkillCheckboxes.push(checkbox);
            }
        });
        
        // Handle "no skills necessary" checkbox change
        noSkillsCheckbox.addEventListener('change', function() {
            if (this.checked) {
                // Uncheck all other skill options
                otherSkillCheckboxes.forEach(checkbox => {
                    checkbox.checked = false;
                    // Trigger change event for Gravity Forms
                    const event = new Event('change', { bubbles: true });
                    checkbox.dispatchEvent(event);
                });
            }
        });
        
        // Handle other skill checkboxes change
        otherSkillCheckboxes.forEach(checkbox => {
            checkbox.addEventListener('change', function() {
                if (this.checked) {
                    // Uncheck "no skills necessary"
                    noSkillsCheckbox.checked = false;
                    // Trigger change event for Gravity Forms
                    const event = new Event('change', { bubbles: true });
                    noSkillsCheckbox.dispatchEvent(event);
                }
            });
        });
    }
});